module.exports = __webpack_public_path__ + "img/sceneTwo.ba89dca5.png";